import type { CSSProperties, ReactNode } from "react";

import { SCREEN_RANGE } from "./units";
import styles from "./Screen.module.css";

const range = {
  "--screen-min-width": SCREEN_RANGE.minWidth,
  "--screen-max-width": SCREEN_RANGE.maxWidth,
  "--screen-min-height": SCREEN_RANGE.minHeight,
  "--screen-max-height": SCREEN_RANGE.maxHeight,
} as CSSProperties;

/**
 * The phone-sized surface the design is drawn onto: Figma's "Mobile Screen"
 * frame, which is fixed there and stretches here.
 *
 * It owns `--u`, one Figma design pixel, so children can be sized in the
 * numbers the file gives them.
 */
export function Screen({ children }: { children: ReactNode }) {
  return (
    <div className={styles.viewport}>
      <div className={styles.screen} style={range} data-screen="">
        {children}
      </div>
    </div>
  );
}
